import moment from 'moment';
import { MomentRange, isWeekend } from '@ally/date-utils';
import { firstBusinessDay, lastBusinessDay, SERVER_DATE_FORMAT, } from '../constants';
export function getFirstOrLastBusinessDay(_a) {
    var federalHolidays = _a.federalHolidays, date = _a.date, frequency = _a.frequency;
    function isHoliday(dt) {
        // Check if date exists in holiday map
        return !!federalHolidays[dt.format(SERVER_DATE_FORMAT)];
    }
    var startDate = moment(date).clone().startOf('month');
    var endDate = moment(date).clone().endOf('month');
    var range = new MomentRange(startDate, endDate);
    switch (frequency) {
        case firstBusinessDay:
            return range.find(function (dt) { return !isWeekend(dt) && !isHoliday(dt); });
        case lastBusinessDay:
            return range.findLast(function (dt) { return !isWeekend(dt) && !isHoliday(dt); });
        default:
            throw new Error('Only the firstBusinessDay or lastBusinessDay frequencies should be passed to getFirstOrLastBusinessDay');
    }
}
export default getFirstOrLastBusinessDay;
//# sourceMappingURL=getFirstOrLastBusinessDay.js.map